import React from "react";
import Sidebar from "../../Component/sidebar";
import { Route, Routes } from "react-router-dom";
import { AdminSidebarData } from "../../module/adminSidebarData";
import AgeGroup from "./ageGroup/ageGroup";
import AddSubCategory from "./subCategory/addSubCategory";
import EditDeleteSubCategory from "./subCategory/editDeleteSubcategory";
import AddProduct from "./createProduct/addProduct";
import EditDeleteProduct from "./createProduct/editDeleteProduct";
import AddTagOption from "./tagOption/addTagOption";
import EditDeleteTagOption from "./tagOption/editDeleteTagOption";
import CreateProductType from "./ProductType/createProductType";
import EditDeleteProductType from "./ProductType/editDeleteProductType";
import CreateCategory from "./Category/createCategory";
import EditDeleteAgeGroup from "./ageGroup/editDeleteAgeGroup";
import EditDeleteCategory from "./Category/editDeleteCategory";
import CreateBlog from "./blog/createBlog";
import EditDeleteBlog from "./blog/editDeleteBlog";

import CreateBaseOffer from "./baseOffer/createBaseOffer";
import EditDeleteBaseOffer from "./baseOffer/editDeleteBaseOffer";
import CreateCouponCode from "./CouponCode/createCouponCode";
import CreateAuthor from "./Author/createAuthor";
import EditDeleteCouponCode from "./CouponCode/editDeleteCouponCode";
import EditDeleteAuthor from "./Author/editDeleteAuthor";
import CreateUser from "./User/createUser";
import DispatchOrder from "./DispachOrder/dispatchOrder";
import AddCategoryVideos from "./Category/addCategoryVideos";
import EditDeleteCategoryVideos from "./Category/editDeleteCategoryVideos";
const AdminDashboard = () => {
  return (
    <>
      <div className="adminDiv d-flex">
        <Sidebar data={AdminSidebarData} />
        <div className="rightSideContainer py-3 px-4">
          <Routes>
            <Route path="/" element={<AgeGroup />} />
            <Route path="ageGroup" element={<AgeGroup />} />
            <Route path="editDeleteAgeGroup" element={<EditDeleteAgeGroup />} />
            <Route path="createProductType" element={<CreateProductType />} />
            <Route
              path="editDeleteProductType"
              element={<EditDeleteProductType />}
            />
            <Route path="createCategory" element={<CreateCategory />} />
            <Route path="editDeleteCategory" element={<EditDeleteCategory />} />
            <Route path="addCategoryVidoes" element={<AddCategoryVideos />} />
            <Route path="editDeleteCategoryVideos" element={<EditDeleteCategoryVideos />} />
            <Route path="addSubCategory" element={<AddSubCategory />} />
            <Route
              path="editDeleteSubcategory"
              element={<EditDeleteSubCategory />}
            />
            <Route path="addTagOption" element={<AddTagOption />} />
            <Route
              path="editDeleteTagOption"
              element={<EditDeleteTagOption />}
            />
            <Route path="addProduct" element={<AddProduct />} />
            <Route path="editDeleteProduct" element={<EditDeleteProduct />} />
            <Route path="createBlog" element={<CreateBlog />} />
            <Route path="editDeleteBlog" element={<EditDeleteBlog />} />
            <Route path="createBaseOffer" element={<CreateBaseOffer />} />
            <Route
              path="editDeleteBaseOffer"
              element={<EditDeleteBaseOffer />}
            />
            <Route path="createCouponCode" element={<CreateCouponCode />} />
            <Route
              path="editDeleteCouponCode"
              element={<EditDeleteCouponCode />}
            />

            <Route path="createAuthor" element={<CreateAuthor />} />
            <Route path="editDeleteAuthor" element={<EditDeleteAuthor />} />
            <Route path="createUser" element={<CreateUser />} />
            <Route path="dispatchOrder" element={<DispatchOrder />} />
          </Routes>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
